<template>
  <div class="container-expanded" v-loading="loadingAgentDetails">
    <el-row type="flex" :gutter="8" class="mt-20" v-if="!loadingAgentDetails">
      <el-col :span="5">
        <el-row type="flex">
          <el-col class="exlclamation-triangle" :span="2" style="margin-left:27px"></el-col>
          <el-col class="high-run-time-risk-header" :span="20" style="color:#000000;">
            <h5>Runtime Status</h5>
            <span>Investigate threats connected to this VM:</span>
          </el-col>
        </el-row>
        <el-row type="flex" class="mt-18">
          <el-col :span="4">
            <!--  place holder span to align col spacing -->
          </el-col>
          <el-col class="high-run-time-risk" :span="18">
            <h5 :span="4" v-if="details.openToPublicInternet">
              <a class="format-link">Open to the Public!</a>
            </h5>
            <router-link
              :to="{
                name: 'account-progressions',
                query: { accountKey: details.containerId, nickName: details.containerNames[0] }
              }"
            >
              <h5>
                <div>
                  <el-col
                    v-if="details.numProgressions !== 0 || details.numDetections !== 0"
                    class="exlclamation-triangle"
                    :span="2"
                    style="margin-left:-24px;"
                    ><img src="/static/images/warning.svg"
                  /></el-col>
                  <el-col v-else class="exlclamation-triangle"></el-col>
                </div>
                <a class="format-link">Progressions: {{ details.numProgressions }}</a>
              </h5>
            </router-link>
            <router-link :to="{ name: 'account-iocs', query: { accountKey: details.containerId } }">
              <h5>
                <a class="format-link">Detections: {{ details.numDetections }}</a>
              </h5>
            </router-link>
            <!-- <router-link :to="{}">
              <h5>
              <a class="format-link">Privileged Activities: {{ details.numProgressions }}</a>
              </h5>
            </router-link> -->
            <!-- <router-link :to="{}">
              <h5>
              <a class="format-link">Anomalies: {{ details.numProgressions }}</a>
              </h5>
            </router-link> -->
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="5" v-if="details.k8s || !$_.isEmpty(details.tags)" style="color:#000000;">
        <el-row type="flex">
          <el-col class="application-content-header" :span="24">
            <h5 class="display-block" style="color:#000000">Application Context</h5>
            <span class="display-block">Insights related to business requirements:</span>
          </el-col>
        </el-row>
        <el-row type="flex" class="mt-18">
          <el-col class="application-context" ref="" :span="24">
            <div class="display-block" v-if="details.k8sClusterKey">
              <h5 class="format-text">Cluster:</h5>
              <span class="value">{{ details.k8sClusterKey }}</span>
            </div>
            <div class="display-block" v-if="details.podName">
              <h5 class="format-text">Pod:</h5>
              <span class="value">{{ details.podName }}</span>
            </div>
            <div class="display-block" v-if="details.podNameSpace">
              <h5 class="format-text">Namespace:</h5>
              <span class="value">{{ details.podNameSpace }}</span>
            </div>
            <div class="display-block" v-if="details.tags">
              <h5 class="format-text">Tags:</h5>
              <span v-for="tag in details.tags" :key="tag" class="value">
                <span>{{ tag }}<br /></span>
              </span>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="5" v-if="agentDetails">
        <el-row type="flex">
          <el-col class="worker-node-receives-header" :span="24">
            <h5 style="color:#000000">Worker Node</h5>
            <span style="color:#000000">Receives and executes tasks from manager nodes</span>
            <br /><br />
            <h5 @click="gotoHost">
              <a class="format-link">Worker Node: {{ agentDetails.customHostname }}</a>
            </h5>
          </el-col>
          <br />
        </el-row>
        <el-row type="flex" class="mt-18">
          <el-col class="agent-checklist-agen" :span="18">
            <h5 class="agent-checklist-agen-header" style="color:#000000">Sensor Checklist</h5>
            <span class="display-block">{{ agentStatusText }}</span>

            <div class="display-block">
              <span class="agent-details-text" style="color:#000000;">
                Installed (Version {{ agentDetails.agentVersion }})</span
              >
            </div>
            <div v-if="!(agentDetails.state === 'DECOMMISSIONABLE' || agentDetails.state === 'OFFLINE')">
              <div class="display-block" v-if="agentDetails.upgradeable">
                <span class="agent-details-text" style="color:#000000;">
                  Needs Upgrade(Version {{ agentDetails.iqhubVersion }})
                </span>
              </div>
              <div class="display-block" v-else>
                <span class="agent-details-text" style="color:#000000;">Up to Date</span>
              </div>
            </div>

            <div class="display-block" v-if="agentDetails.state === 'DECOMMISSIONED'">
              <span class="agent-details-text" style="color:#000000;">Sensor is Decommissioned</span>
            </div>
            <div class="display-block" v-else-if="agentDetails.state === 'OFFLINE'">
              <span class="agent-details-text" style="color:#000000;">Sensor is Offline</span>
            </div>
            <div class="display-block" v-else-if="agentDetails.state === 'DECOMMISSIONABLE'">
              <span class="agent-details-text" style="color:#000000;">Sensor is Offline and can be Decommissioned</span>
            </div>
            <div class="display-block" v-else>
              <span class="agent-details-text" style="color:#000000;"> Found</span>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="5">
        <el-row type="flex">
          <el-col class="high-image-header" style="color:#000000;" :span="24">
            <!-- <el-col class="exlclamation-triangle" :span="4"><img src="static/images/warning.svg" /></el-col> -->
            <h5 class="display-block">Image Risk Status</h5>
            <div class="display-block">
              <span class="formet-text">1. Image ID: </span>
              <span class="value word-break">{{ details.containerImageId }}</span>
            </div>
            <div>
              <el-col
                v-if="
                  details.vulnerable === 'UNKNOWN' ||
                    details.vulnHighScore !== 0 ||
                    details.vulnMedScore !== 0 ||
                    details.vulnLowScore !== 0
                "
                class="exlclamation-triangle"
                :span="2"
                style="margin-left:-30px"
                ><img src="static/images/warning.svg"
              /></el-col>
              <el-col v-else :span="2" style="margin-left:-30px"></el-col>
            </div>
            <div class="display-block">
              <div v-if="details.vulnerable === 'UNKNOWN'">
                <span class="formet-text">2. Vulnerability: </span>
                <span class="value">Unknown</span>
              </div>
              <div v-else>
                <span class="formet-text">2. Vulnerability: </span>
                <span class="value">High - {{ details.vulnHighScore }}</span>
                <span class="value">Med - {{ details.vulnMedScore }}</span>
                <span class="value">Low - {{ details.vulnLowScore }}</span>
              </div>
            </div>
            <br />
            <div class="display-block" v-if="details.vulnerable !== 'UNKNOWN' && details.vulnerable !== 'NO'">
              <a class="format-link" href="https://app.snyk.io/login" target="_blank" rel="noreferrer"> Go to Snyk</a>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4" v-if="agentDetails">
        <el-row type="flex">
          <div class="display-block">
            <el-button class="btn-more-details" size="medium" round @click="gotoHost"><b>Worker Node</b></el-button>
          </div>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { AGENT_DETAILS_REQ } from '@/store/modules/agents/agents.type'

export default {
  name: 'ExpandContainerDetails',
  props: {
    details: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      loadingAgentDetails: false
    }
  },
  methods: {
    gotoHost () {
      this.$router.push({
        name: 'hosts',
        query: { agentId: this.agentDetails.customHostname }
      })
    },
    loadAgentDetails () {
      this.loadingAgentDetails = true
      this.$store.dispatch(AGENT_DETAILS_REQ, this.details.agentId).then(
        agent => {
          this.loadingAgentDetails = false
          this.details.agentDetails = agent
        },
        errMsg => {}
      )
    }
  },
  created () {
    if (this.details.agentId && _.isEmpty(this.details.agentDetails)) {
      this.loadAgentDetails()
    }
  },
  computed: {
    ...mapGetters([]),
    agentDetails () {
      if (this.details.agentDetails) {
        return this.details.agentDetails
      }
      return false
    },
    agentStatusText () {
      let text = 'Sensor is '
      if (['DECOMMISSIONABLE', 'OFFLINE'].includes(this.details.agentDetails.state)) {
        text += 'offline'
      } else {
        text += this.details.agentDetails.upgradeable ? 'active and needs upgrade' : 'active and up to date'
      }

      return text
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.container-expanded {
  padding: 20px;
  background: var(--aluminum-200);
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #d7dbe0;
  background-color: #f8fcff;
}

.material-icons {
  font-size: 1.3em;
  line-height: 36px;
  vertical-align: middle;
  color: var(--gray-500);
  background: transparent;
}

.el-divider--vertical {
  margin: 0px;
}

>>> .el-button {
  background-color: var(--aluminum-800);
  color: white;
  border-radius: 5px;
  background-color: #77dab4;

  a {
    text-decoration: none;
    color: white;
  }
}

.footer-buttons {
  &.center {
    margin: auto;
  }
}

.btn-more-details {
  float: right;
  height: 40px;
  width: 152px;
}

.high-run-time-risk {
  height: 220px;
  width: 156px;
  color: #1a90fa;
  /* font-family: Montserrat; */
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 20px;
}

.high-run-time-risk-header {
  /* height: 220px; */
  width: 156px;
}

.format-text {
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
  display: inline;
  color: #000000;
}

.format-link {
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
  display: inline;
  color: #1a90fa;
}

.application-context {
  height: 322px;
  width: 175px;
  color: #292c32;
  /* font-family: Montserrat; */
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
}

.application-content-header {
  width: 175px;
}

.worker-node-receives {
  height: 160px;
  width: 181px;
  /* color: #1A90FA; */
  /* font-family: Montserrat; */
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 20px;
}

.worker-node-receives-header {
  width: 181px;
}

.agent-checklist-agen {
  height: 140px;
  width: 184px;
  color: #292c32;
  /* font-family: Montserrat; */
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
}

.agent-checklist-agen-header {
  width: 184px;
}

.high-image-header {
  width: 125px;
}

.agent-details-text {
  font-size: 13px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 20px;
  display: inline;
}

.rectangle-copy-4-1 {
  box-sizing: border-box;
  height: 354px;
  width: 1296px;
  border: 1px solid #d7dbe0;
  border-radius: 2px;
  background-color: #f8fcff;
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/expand/ExpandContainerDetails.vue